import React from 'react';
import { Port } from '../../types';
import { portService } from '../../services';
import { EntityPickerModal } from './EntityPickerModal';
import { createMultiFieldFilter } from '../../search/filterBuilders';

interface ChangeDestinationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (portId: string) => void;
  carCount: number;
}

export const ChangeDestinationModal: React.FC<ChangeDestinationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  carCount,
}) => {
  return (
    <EntityPickerModal<Port>
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Change Destination"
      description={`Select the port of discharge for ${carCount} ${carCount === 1 ? 'car' : 'cars'}.`}
      confirmLabel="Change Destination"
      placeholder="Search by code, port name, or country"
      loadOptions={async () => (await portService.getAll({ limit: 1000 })) as Port[]}
      getKey={(p) => p.id}
      getPrimary={(p) => (
        <div>
          <div className="font-semibold text-gray-900 dark:text-gray-100">{p.code}</div>
          <div className="text-sm text-gray-600 dark:text-gray-400">{p.port}</div>
        </div>
      )}
      getSecondary={(p) => <div>{p.country}</div>}
      filter={createMultiFieldFilter<Port>(
        p => p.code,
        p => p.port,
        p => p.country
      )}
    />
  );
};

export default ChangeDestinationModal;
